import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import { TIME_FORMAT, NOTIFICATION_DATE_FORMAT } from '@common/DateFormats';

import LinkWrapper from '@components/LinkWrapper';

export default function NotificationItem({
  id,
  status,
  notification,
  updateNotificationStatus,
}) {
  return (
    <li key={id} className={status}>
      {!!notification.url && (
        <LinkWrapper
          url={notification.url}
          onClick={() => {
            if (status === 'pending') {
              updateNotificationStatus(id);
            }
          }}
        />
      )}
      <div className='date'>
        {format(new Date(notification.createdAt), NOTIFICATION_DATE_FORMAT)}
      </div>
      <div className='time'>
        {format(new Date(notification.createdAt), TIME_FORMAT)}
      </div>
      <p className='title'>{notification.content}</p>
    </li>
  );
}

NotificationItem.propTypes = {
  id: PropTypes.number.isRequired,
  notification: PropTypes.object.isRequired,
  status: PropTypes.oneOf([
    'pending',
    'seen',
    'deleted',
  ]).isRequired,
  updateNotificationStatus: PropTypes.func.isRequired,
};
